import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

export interface DriverState {
  activeStep: number;
}

const initialState: DriverState = {
  activeStep: 0,
};

export const driverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    setActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    },
  },
});

export const { setActiveStep } = driverSlice.actions;

export default driverSlice.reducer;
